<script>
	import { Switcher } from "./main";
	import AccordionDemo from './demo/AccordionDemo.svelte';
	import AlertDemo from './demo/AlertDemo.svelte';
	import AsyncAutocompleteDemo from './demo/AsyncAutocompleteDemo.svelte';
	import AsyncDataTableDemo from './demo/AsyncDataTableDemo.svelte';
	import AutocompleteDemo from './demo/AutocompleteDemo.svelte';
	import BadgeDemo from './demo/BadgeDemo.svelte';
	import DataTableDemo from './demo/DataTableDemo.svelte';
	import FixedPointInputDemo from './demo/FixedPointInputDemo.svelte';
	import FormDemo from './demo/FormDemo.svelte';
	import FormModalDemo from './demo/FormModalDemo.svelte';
	import ModalDemo from './demo/ModalDemo.svelte';
	import OffcanvasDemo from './demo/OffcanvasDemo.svelte';
	import OrderableListDemo from './demo/OrderableListDemo.svelte';
	import PaginationDemo from './demo/PaginationDemo.svelte';
	import PasswordInputAltDemo from './demo/PasswordInputAltDemo.svelte';
	import RadioDemo from './demo/RadioDemo.svelte';
	import ScrollableNavDemo from './demo/ScrollableNavDemo.svelte';
	import SelectDemo from './demo/SelectDemo.svelte';
	import SwitcherDemo from './demo/SwitcherDemo.svelte';
	import TabDemo from './demo/TabDemo.svelte';
	import TableDemo from './demo/TableDemo.svelte';
</script>
<style>
	code {
		white-space: pre;
	}
</style>
<div uk-grid class="uk-flex-center uk-padding-small">
	<div class="uk-width-3-5@l uk-width-2-3@m uk-width-5-6@s uk-width-1-1">
		<h2 class="uk-heading-divider">Autocomplete</h2>
		<p></p>
		<Switcher titles={['Output', 'Code']}>
			<li>
				<hr class="uk-divider-icon">
				<AutocompleteDemo />
				<hr class="uk-divider-icon">
			</li>
			<li><pre>&lt;script&gt;
&nbsp;&nbsp;import &lbrace; tick &rbrace; from &quot;svelte&quot;;

&nbsp;&nbsp;import &lbrace; Autocomplete, Checkbox, Form &rbrace; from &quot;../main&quot;;

&nbsp;&nbsp;const options = [
&nbsp;&nbsp;&nbsp;&nbsp;&lbrace;
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;label: &quot;Ananas&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;value: 1,
&nbsp;&nbsp;&nbsp;&nbsp;&rbrace;,
&nbsp;&nbsp;&nbsp;&nbsp;&lbrace;
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;label: &quot;Banana&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;value: &lbrace; kg: &quot;3.14&quot; &rbrace;,
&nbsp;&nbsp;&nbsp;&nbsp;&rbrace;,
&nbsp;&nbsp;&nbsp;&nbsp;&lbrace;
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;label: &quot;Bananana&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;value: &lbrace; kg: &quot;6.28&quot; &rbrace;,
&nbsp;&nbsp;&nbsp;&nbsp;&rbrace;,
&nbsp;&nbsp;&nbsp;&nbsp;&lbrace;
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;label: &quot;Strawberry&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;value: &quot;strawberry&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&rbrace;,
&nbsp;&nbsp;];

&nbsp;&nbsp;$: console.log(value);

&nbsp;&nbsp;let multi = false;
&nbsp;&nbsp;let value;
&nbsp;&nbsp;function handleMultiChange() &lbrace;
&nbsp;&nbsp;&nbsp;&nbsp;value = multi ? [&quot;strawberry&quot;] : &quot;strawberry&quot;;
&nbsp;&nbsp;&rbrace;
&nbsp;&nbsp;$: multi, tick().then(() =&gt; handleMultiChange());
&lt;/script&gt;

&lt;Checkbox bind:value=&lbrace;multi&rbrace; label=&quot;Enable multiple value selection&quot; /&gt;
&lt;Form submitAsync=&lbrace;() =&gt; alert(value)&rbrace;&gt;
&nbsp;&nbsp;&lt;Autocomplete
&nbsp;&nbsp;&nbsp;&nbsp;&lbrace;multi&rbrace;
&nbsp;&nbsp;&nbsp;&nbsp;bind:value
&nbsp;&nbsp;&nbsp;&nbsp;&lbrace;options&rbrace;
&nbsp;&nbsp;&nbsp;&nbsp;label=&lbrace;&quot;Search a fruit&quot;&rbrace;
&nbsp;&nbsp;&nbsp;&nbsp;placeholder=&lbrace;&quot;Banana&quot;&rbrace;
&nbsp;&nbsp;&nbsp;&nbsp;textIfNoResult=&lbrace;&quot;No match&quot;&rbrace;
&nbsp;&nbsp;&nbsp;&nbsp;on:change=&lbrace;(e) =&gt; console.log(e)&rbrace;
&nbsp;&nbsp;/&gt;
&lt;/Form&gt;
</pre></li>
		</Switcher>
		<h3>Props</h3>
		<table class="uk-table">
			<thead>
				<tr>
					<th>name</th>
					<th>type</th>
					<th>default</th>
					<th>description</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>id</td>
					<td>string</td>
					<td>generateId()</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>options</td>
					<td>Array.&lt;&lbrace;label: string, value: any&rbrace;&gt;</td>
					<td>[]</td>
					<td>Autocomplete options, the value must be unique</td>
				</tr>
				<tr>
					<td>multi</td>
					<td>boolean</td>
					<td>false</td>
					<td>Whether or not the autocomplete supports multiple values selected at the same time</td>
				</tr>
				<tr>
					<td>value</td>
					<td>any|null|Array.&lt;any&gt;</td>
					<td>!multi ? null : []</td>
					<td>If not in multi-mode (default): the current selected value or null if no value is selected
Else: the list of currently selected values</td>
				</tr>
				<tr>
					<td>label</td>
					<td>string</td>
					<td>""</td>
					<td>Label of this component</td>
				</tr>
				<tr>
					<td>className</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>A string containing any additional classes to apply to the component</td>
				</tr>
				<tr>
					<td>style</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>A string specifying custom style properties for the component</td>
				</tr>
				<tr>
					<td>textIfNoResult</td>
					<td>string</td>
					<td>""</td>
					<td>Text to show when the applied filter doesn't return any result</td>
				</tr>
				<tr>
					<td>textIfInvalid</td>
					<td>string</td>
					<td>""</td>
					<td>Text to show when the field is required but no value has been chosen</td>
				</tr>
				<tr>
					<td>disabled</td>
					<td>boolean</td>
					<td>false</td>
					<td>Control whether the component is disabled or not</td>
				</tr>
				<tr>
					<td>tooltip</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>UIkit tooltip</td>
				</tr>
				<tr>
					<td>placeholder</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>Input placeholder</td>
				</tr>
				<tr>
					<td>optional</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>ref</td>
					<td>HTMLDivElement</td>
					<td>undefined</td>
					<td>Reference to the div that wraps this component</td>
				</tr>
				<tr>
					<td>autocapitalize</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>Autocapitalize setting of the input tag</td>
				</tr>
				<tr>
					<td>autocomplete</td>
					<td>string|undefined</td>
					<td>"off"</td>
					<td>Autocomplete setting of the input tag</td>
				</tr>
				<tr>
					<td>autocorrect</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>Autocorrect setting of the input tag</td>
				</tr>
				<tr>
					<td>spellcheck</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>animationDuration</td>
					<td>number</td>
					<td>100</td>
					<td>In/Out fly animation duration (in milliseconds)</td>
				</tr>
				<tr>
					<td>state</td>
					<td>'initial'|'valid'|'invalid'</td>
					<td>"initial"</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>query</td>
					<td>string</td>
					<td>""</td>
					<td>The current search string</td>
				</tr>
				<tr>
					<td>selectedOptions</td>
					<td>Array.&lt;&lbrace;label: string, value: any&rbrace;&gt;</td>
					<td>[]</td>
					<td>Currently selected options</td>
				</tr>
				<tr>
					<td>requiredMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optionalMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
			</tbody>
		</table>
		<h2 class="uk-heading-divider">Checkbox</h2>
		<p></p>
		<h3>Props</h3>
		<table class="uk-table">
			<thead>
				<tr>
					<th>name</th>
					<th>type</th>
					<th>default</th>
					<th>description</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>id</td>
					<td>string</td>
					<td>generateId()</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>label</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>style</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>A string specifying custom style properties for the component</td>
				</tr>
				<tr>
					<td>className</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>name</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfInvalid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfValid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>helperText</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optional</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>value</td>
					<td>boolean</td>
					<td>-</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>ref</td>
					<td>HTMLInputElement</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>disabled</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>tooltip</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>requiredMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optionalMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>state</td>
					<td>'initial'|'valid'|'invalid'</td>
					<td>"initial"</td>
					<td>undefined</td>
				</tr>
			</tbody>
		</table>
		<h2 class="uk-heading-divider">DatePicker</h2>
		<p></p>
		<h3>Props</h3>
		<table class="uk-table">
			<thead>
				<tr>
					<th>name</th>
					<th>type</th>
					<th>default</th>
					<th>description</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>id</td>
					<td>string</td>
					<td>generateId()</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>label</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>style</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>A string specifying custom style properties for the component</td>
				</tr>
				<tr>
					<td>className</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>name</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfInvalid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfValid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>helperText</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>placeholder</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optional</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>value</td>
					<td>string</td>
					<td>-</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>ref</td>
					<td>HTMLInputElement</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>disabled</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>tooltip</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>min</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>max</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocapitalize</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocomplete</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocorrect</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>spellcheck</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>requiredMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optionalMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>state</td>
					<td>'initial'|'valid'|'invalid'</td>
					<td>"initial"</td>
					<td>undefined</td>
				</tr>
			</tbody>
		</table>
		<h2 class="uk-heading-divider">EmailInput</h2>
		<p></p>
		<h3>Props</h3>
		<table class="uk-table">
			<thead>
				<tr>
					<th>name</th>
					<th>type</th>
					<th>default</th>
					<th>description</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>id</td>
					<td>string</td>
					<td>generateId()</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>label</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>style</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>A string specifying custom style properties for the component</td>
				</tr>
				<tr>
					<td>className</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>name</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfInvalid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfValid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>helperText</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>placeholder</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optional</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>value</td>
					<td>string</td>
					<td>-</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>ref</td>
					<td>HTMLInputElement</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>disabled</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>tooltip</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocapitalize</td>
					<td>string|undefined</td>
					<td>'off'</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocomplete</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocorrect</td>
					<td>string|undefined</td>
					<td>'off'</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>spellcheck</td>
					<td>string|undefined</td>
					<td>'off'</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>requiredMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optionalMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>state</td>
					<td>'initial'|'valid'|'invalid'</td>
					<td>"initial"</td>
					<td>undefined</td>
				</tr>
			</tbody>
		</table>
		<h2 class="uk-heading-divider">Field</h2>
		<p></p>
		<h3>Props</h3>
		<table class="uk-table">
			<thead>
				<tr>
					<th>name</th>
					<th>type</th>
					<th>default</th>
					<th>description</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>style</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>A string specifying custom style properties for the component</td>
				</tr>
				<tr>
					<td>state</td>
					<td>'initial'|'valid'|'invalid'</td>
					<td>"initial"</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>requiredMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optionalMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
			</tbody>
		</table>
		<h2 class="uk-heading-divider">FixedPointInput</h2>
		<p></p>
		<Switcher titles={['Output', 'Code']}>
			<li>
				<hr class="uk-divider-icon">
				<FixedPointInputDemo />
				<hr class="uk-divider-icon">
			</li>
			<li><pre>&lt;script&gt;
  import &lbrace;
    Accordion,
    AccordionItem,
    Checkbox,
    Button,
    FixedPointInput,
  &rbrace; from &quot;../main&quot;;

  let decimalPlaces = 2;
  function increasePrecision() &lbrace;
    decimalPlaces = Math.min(100, decimalPlaces + 1);
  &rbrace;
  function decreasePrecision() &lbrace;
    decimalPlaces = Math.max(decimalPlaces - 1, 0);
  &rbrace;
&lt;/script&gt;

&lt;div class=&quot;uk-flex uk-flex-middle&quot;&gt;
  &lt;Button size=&quot;small&quot; on:click=&lbrace;increasePrecision&rbrace; className=&quot;uk-margin-right&quot;&gt;
    + precision
  &lt;/Button&gt;
  &lt;Button size=&quot;small&quot; on:click=&lbrace;decreasePrecision&rbrace;&gt;- precision&lt;/Button&gt;
&lt;/div&gt;
&lt;FixedPointInput &lbrace;decimalPlaces&rbrace; value=&lbrace;10.33&rbrace; /&gt;
</pre></li>
		</Switcher>
		<h3>Props</h3>
		<table class="uk-table">
			<thead>
				<tr>
					<th>name</th>
					<th>type</th>
					<th>default</th>
					<th>description</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>id</td>
					<td>string</td>
					<td>generateId()</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>decimalPlaces</td>
					<td>number</td>
					<td>2</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>inhibitDecimalSeparatorKey</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>label</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>style</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>A string specifying custom style properties for the component</td>
				</tr>
				<tr>
					<td>className</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfInvalid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfValid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>helperText</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optional</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>value</td>
					<td>string</td>
					<td>-</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>min</td>
					<td>string|number</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>max</td>
					<td>string|number</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>ref</td>
					<td>HTMLInputElement</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>disabled</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>tooltip</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>icon</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>iconPosition</td>
					<td>'left'|'right'</td>
					<td>"left"</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>state</td>
					<td>'initial'|'valid'|'invalid'</td>
					<td>"initial"</td>
					<td>undefined</td>
				</tr>
			</tbody>
		</table>
		<h2 class="uk-heading-divider">MonthPicker</h2>
		<p></p>
		<h3>Props</h3>
		<table class="uk-table">
			<thead>
				<tr>
					<th>name</th>
					<th>type</th>
					<th>default</th>
					<th>description</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>id</td>
					<td>string</td>
					<td>generateId()</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>label</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>style</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>A string specifying custom style properties for the component</td>
				</tr>
				<tr>
					<td>className</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>name</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfInvalid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfValid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>helperText</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>placeholder</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optional</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>value</td>
					<td>string</td>
					<td>-</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>ref</td>
					<td>HTMLInputElement</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>disabled</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>tooltip</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocapitalize</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocomplete</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocorrect</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>spellcheck</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>requiredMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optionalMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>state</td>
					<td>'initial'|'valid'|'invalid'</td>
					<td>"initial"</td>
					<td>undefined</td>
				</tr>
			</tbody>
		</table>
		<h2 class="uk-heading-divider">NumberInput</h2>
		<p></p>
		<h3>Props</h3>
		<table class="uk-table">
			<thead>
				<tr>
					<th>name</th>
					<th>type</th>
					<th>default</th>
					<th>description</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>id</td>
					<td>string</td>
					<td>generateId()</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>label</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>style</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>A string specifying custom style properties for the component</td>
				</tr>
				<tr>
					<td>className</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>name</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfInvalid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfValid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>helperText</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>placeholder</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optional</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>value</td>
					<td>string</td>
					<td>-</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>ref</td>
					<td>HTMLInputElement</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>min</td>
					<td>number|string</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>max</td>
					<td>number|string</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>step</td>
					<td>number|string</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>disabled</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>tooltip</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>icon</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>iconPosition</td>
					<td>'left'|'right'</td>
					<td>"left"</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocapitalize</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocomplete</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocorrect</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>spellcheck</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>requiredMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optionalMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>state</td>
					<td>'initial'|'valid'|'invalid'</td>
					<td>"initial"</td>
					<td>undefined</td>
				</tr>
			</tbody>
		</table>
		<h2 class="uk-heading-divider">PasswordInput</h2>
		<p></p>
		<h3>Props</h3>
		<table class="uk-table">
			<thead>
				<tr>
					<th>name</th>
					<th>type</th>
					<th>default</th>
					<th>description</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>id</td>
					<td>string</td>
					<td>generateId()</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>label</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>style</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>A string specifying custom style properties for the component</td>
				</tr>
				<tr>
					<td>className</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>name</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfInvalid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfValid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>helperText</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>placeholder</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optional</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>value</td>
					<td>string</td>
					<td>-</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>ref</td>
					<td>HTMLInputElement</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>disabled</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>tooltip</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocapitalize</td>
					<td>string|undefined</td>
					<td>"off"</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocomplete</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocorrect</td>
					<td>string|undefined</td>
					<td>"off"</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>spellcheck</td>
					<td>string|undefined</td>
					<td>"off"</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>minlength</td>
					<td>number|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>maxlength</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>requiredMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optionalMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>state</td>
					<td>'initial'|'valid'|'invalid'</td>
					<td>"initial"</td>
					<td>undefined</td>
				</tr>
			</tbody>
		</table>
		<h2 class="uk-heading-divider">PasswordInputAlt</h2>
		<p></p>
		<Switcher titles={['Output', 'Code']}>
			<li>
				<hr class="uk-divider-icon">
				<PasswordInputAltDemo />
				<hr class="uk-divider-icon">
			</li>
			<li><pre>&lt;script&gt;
import &lbrace; PasswordInputAlt &rbrace; from &quot;../main&quot;;

let password = &quot;hello1234&quot;;
&lt;/script&gt;

&lt;PasswordInputAlt bind:value=&lbrace;password&rbrace; /&gt;
</pre></li>
		</Switcher>
		<h3>Props</h3>
		<table class="uk-table">
			<thead>
				<tr>
					<th>name</th>
					<th>type</th>
					<th>default</th>
					<th>description</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>id</td>
					<td>string</td>
					<td>generateId()</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>label</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>style</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>A string specifying custom style properties for the component</td>
				</tr>
				<tr>
					<td>className</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>name</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfInvalid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>textIfValid</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>helperText</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>placeholder</td>
					<td>string</td>
					<td>""</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optional</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>value</td>
					<td>string</td>
					<td>-</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>ref</td>
					<td>HTMLInputElement</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>disabled</td>
					<td>boolean</td>
					<td>false</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>tooltip</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocapitalize</td>
					<td>string|undefined</td>
					<td>"off"</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocomplete</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>autocorrect</td>
					<td>string|undefined</td>
					<td>"off"</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>spellcheck</td>
					<td>string|undefined</td>
					<td>"off"</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>minlength</td>
					<td>number|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>maxlength</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>requiredMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>optionalMarker</td>
					<td>string|undefined</td>
					<td>undefined</td>
					<td>undefined</td>
				</tr>
				<tr>
					<td>state</td>
					<td>'initial'|'valid'|'invalid'</td>
					<td>"initial"</td>
					<td>undefined</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>